import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/router'
import store from '@/store/store'
import VueHoneybadger from '@honeybadger-io/vue'
import VueFormulate from '@braid/vue-formulate'
import VueChangeCase from '@/plugins/vue-change-case'
import VueShopify from '@/plugins/vue-shopify'
import VueSegment from 'vue-segment-analytics'
import VueNotify from '@/plugins/vue-notify'
import BaseToggle from '@/components/BaseToggle/BaseToggle'
import '@/assets/styles/main.scss'

store.dispatch('setShopOrigin')

Vue.use(VueHoneybadger, {
  apiKey: process.env.VUE_APP_HONEYBADGER_API_KEY,
  environment: process.env.VUE_APP_ENV,
  developmentEnvironments: ['development']
})
Vue.use(VueShopify)
Vue.use(VueChangeCase)
Vue.use(VueNotify)
Vue.use(VueSegment, { id: process.env.VUE_APP_SEGMENT_WRITE_KEY })
Vue.use(VueFormulate, { library: { toggle: { classification: 'box', component: BaseToggle } } })

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
